import React from "react";
import {
  Title,
  P,
  ListMain,
  ListSec,
  LiTitle,
  LiTextBold,
  TextWithOpacity,
} from "./style";
import { TermsContainer } from "../../../CommonStyles";

const PolicyTermsEng = () => {
  return (
    <TermsContainer style={{height: '270px'}}  lngDirection="eng">
      <Title>WEBSITE REGULATIONS</Title>
      <TextWithOpacity>January 2020</TextWithOpacity>

      <P>Welcome to the Zikaron BaSalon Foundation website.</P>
      <P>
        The Zikaron BaSalon Foundation wishes to enables and create an open
        dialogue about remembrance of the Holocaust and its effect on society in
        the past, the present and the future, amongst others by means of aiding
        in the organization of home meetings between hosts and guests (as
        defined hereinafter), some of them testifiers (as defined hereinafter)
        who recount to the audience of guests and others their stories and
        experiences from the time of the Holocaust. The meetings take place at
        various locations in the homes of the hosts throughout Israel (and in
        other countries worldwide). Through these meetings Zikaron BaSalon
        wishes to honour and preserve the remembrance of the Holocaust for
        future generations.
      </P>
      <P>
        These regulations (“the regulations”) arrange the relationship between
        the testifiers, the hosts and the guests in a Zikaron BaSalon activity,
        including website surfers (”the participants”) and sets out the rules
        according to which the participants can take part in the Foundation’s
        activity. These regulations constitute a binding contract between the
        participants and Zikaron BaSalon. Please read the regulations
        thoroughly, as surfing and/or registration and/or any other use of the
        website shall be considered as consent to the rules detailed in these
        regulations.
      </P>
      <P>
        These regulations are worded in the masculine gender solely for
        convenience and they relate to both genders equally. In any place in
        which the wording of the content of the website is in the singular form
        it relates to both the singular and plural forms accordingly.{" "}
      </P>
      <P>
        The internet websites:
        {
          <a
            href="http://zikaronbasalon.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            zikaronbasalon.org
          </a>
        }{" "}
        ,{" "}
        {
          <a
            href="http://zikaronbasalon.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            zikaronbasalon.com
          </a>
        }{" "}
        ו-{" "}
        {
          <a
            href="http://zikaronbasalon.herokuapp.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            zikaronbasalon.herokuapp.com
          </a>
        }
        (hereinafter jointly: “the website”) are operated by the Zikaron BaSalon
        Foundation, a registered foundation No. 580662070, of 4/11 Peat
        Hashulchan Street, Tel Aviv-Jaffa and/or its representative (above and
        hereinafter: “Zikaron BaSalon”). For any question or enquiry in regard
        to the website please contact the offices of Zikaron BaSalon by means of
        email:
        {
          <a
            href="mailto:info@zikaronbasalon.com"
            target="_self"
            data-content="info@zikaronbasalon.com"
            data-type="mail"
          >
            info@zikaronbasalon.com
          </a>
        }
        .
      </P>
      <P>
        In any place in which the term “Zikaron BaSalon” appears in this
        website, the intention is to Zikaron BaSalon and/or its employees and/or
        its service providers and/or its representatives, accordingly.
      </P>
      <P>
        Surfiing and/or use by you of the website, in any shape or form
        constitutes your consent and confirmation to that stated in these
        regulations and your undertaking pursuant to it. Zikaron BaSalon
        reserves its right to update and amend the provisions of these
        regulations including the terms of use from time to time, subject to any
        law, at its sole discretion, and without the need to notify of such in
        advance. The validity of any update or amendment to these regulations
        including the terms of use incorporated therein shall be imposed from
        the time of its publication on the website unless it shall be stated
        otherwise. Zikaron BaSalon shall notify of any significant changes in
        the regulations in a prominent position on the website. Moreover, it is
        recommended that you read the regulations from time to time in order to
        be updated and ascertain that you are aware of the terms. Your use of
        the website constitutes your unconditional consent to the terms of these
        regulations including the privacy policy, on each entry to the website.
        If you do not agree with the terms of use for the website, in entirety
        or in part, do not make use of the website for any objective whatsoever,
        and you shall not have any plea, claim and/or demand vis-à-vis Zikaron
        BaSalon or its representative.
      </P>
      <ListMain>
        <li>
          <P>
            <LiTitle>DEFINITIONS</LiTitle>
          </P>
          <ListSec>
            <li>
              “Testifiers” – Holocaust survivors, second generation of the
              Holocaust, third generation of the Holocaust and humanities and
              academia experts on Holocaust research.
            </li>
            <li>“Host” – one who wishes to host a Zikaron BaSalon meeting. </li>
            <li>
              “Meeting” – an event with the participation of a host/s, guests,
              and sometimes including a testifier.{" "}
            </li>
            <li>“Guest” – one who wishes to participate in a meeting.</li>
            <li>
              Surfer” – anyone who surfs or makes any use of the website,
              whether he is a host, guest, testifier or other.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>THE WEBSITE SERVICES</LiTitle>
          </P>
          <ListSec>
            <li>
              The website constitutes a platform which assists in the
              organization of the Zikaraon BaSalon activities, and inter alia
              organizing the meetings, which constitute intimate remembrance
              evenings, and it serves the hosts, the testifiers and guests as
              one.
            </li>
            <li>
              Furthermore, the website could contain diverse contents that shall
              be uploaded and shared at the discretion of Zikaron BaSalon or its
              representative, including movies, recordings, written testimonies,
              various documenbts and referral to other websites.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>TESTIFIERS</LiTitle>
          </P>
          <ListSec>
            <li>
              A testifier who wishes to recount his story in a meeting shall
              transfer the following details to the Zikaron BaSalon
              representative and/or shall register via the website and enter the
              following details into the designated place on the website: first
              name and surname, telephone of the testifier, email of the
              testifier, telephone of a contact person on behalf of the
              testifier, email of the contact person on behalf of the testifier,
              the relationship of the contact person to the testifier, the full
              residential address, the dates suitable for the meeting, the
              language in which the testifier wishes to recount his story,
              accessibility requests (does he require an elevator, microphone or
              any auxiliary accessory), and a short background about his story.
              It shall be clarified that transfer of the details does not
              obligate Zikaron BaSalon to organize a meeting and/or to invite
              the testifier to a meeting.
            </li>
            <li>
              Zikaron BaSalon does not have responsibility for the truth and/or
              the content of the testifier’s story, and it is based solely and
              only on the testifier’s memory.
            </li>
            <li>
              Inasmuch as the testifier provides his details to the website (or
              by any other method) by means of a third party whgo is not a
              representative of Zikaron BaSalon (“the referring individual”) the
              referring individual declares and confirms that he has received
              the explicit consent in advance of the testifier to provide his
              details to Zikaron BaSalon, and the terms of these regulations
              shall be imposed on the testifier and on the referring individual
              jointly and severally..
            </li>
            <li>
              The testifier is responsible for arriving at the meeting on the
              date and time coordinated with him and to inform Zikaron BaSalon
              and the host as soon as possible as to any delay or other
              circumstances which preclude him from participating in the
              meeting. Zikaron BaSalon has no liability and/or undertaking in
              regard to the arrival of the testifier to the host’s home and/or
              in regard to the testifier’s personal or medical circumstances.
            </li>
            <li>
              The testifier shall arrive at the meeting and shall participate in
              it of his own free consent and will.{" "}
            </li>
            <li>
              The testifier declares that there is no legal, contractual or
              other preclusion for his participation in the meeting, and that
              all the details that he has provided to Zikaron BaSalon by means
              of the website (or by any other method) are correct and accurate.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>HOST</LiTitle>
          </P>
          <ListSec>
            <li>
              A host wishing to host a meeting can register by means of the
              website and accordingly enter in the designated place for such on
              the website the following details: first name and surname,
              telephone, email, languages that the host speaks, residential
              address and floor, details about accessibility (whether there is
              an elevator, stairs at the entrance to the building etc), the
              requested dates and times for the meeting, the minimum and maximum
              number of guests that he can host and any other relevant detail to
              coordinate the meeting. It shall be clarified that the very
              transfer of details does not obligate Zikaron BaSalon to
              coordinate a meeting with the host.
            </li>
            <li>
              Zikaron Basalon is permitted, however is not obligated, to help in
              coordination of the meetings between hosts and testifiers.{" "}
            </li>
            <li>
              A host shall not unreasonably refuse to host any testifier and/or
              guest at the meeting.{" "}
            </li>
            <li>
              The host agrees that his first name and address (town and street
              name) shall be published on the website for the purpose of
              coordinating the meetings. The host may choose to share the
              details of the meeting which he shall host on social networks by
              using the link to the Zikaron BaSalon website.
            </li>
            <li>
              The host may choose to close registration for the meeting in his
              home, and not to enable additional guests to register for the
              meeting as aforementioned.{" "}
            </li>
            <li>
              For the purpose of cancelling a meeting the host shall send a
              cancellation request to Zikaron BaSalon in writing to the email:
              info@zikaronbasalon.com{" "}
            </li>
            <li>
              The host shall be solely responsible to inform the testifier and
              the guests who registered for the meeting as to cancellation of
              the meeting and/or as to any change in the details of the meeting,
              as soon as possible.
            </li>
            <li>
              The host declares that there is no legal, contractual or other
              preclusion from hosting the meeting in his home and that all the
              details transferred bv him to Zikaron BaSalon on the website (or
              by any other method) are correct and accurate.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>GUESTS</LiTitle>
          </P>
          <ListSec>
            <li>
              A guest who wishes to receive notification where a meeting is
              taking place can register by means of the website and enter the
              following details into the place designated for such on the
              website: first name and surname, telephone, email, address, the
              preferred location to be a guest, the language in which he would
              prefer to hear the story of the testifier and requests for
              accessibility inasmuch as there are such. It shall be clarified
              that the very transfer of the details by the guest does not
              obligate Zikaron BaSalon and/or the hosts to invite the guest to
              the meetings.
            </li>
            <li>
              For the purpose of participation in meetings, the guest shall send
              by means of the website a request to be a guest. Zikaron BaSalon
              does not undertake to accept the requests as aforementioned, in
              entirety or in part, and the guest shall not have any complaint
              about such.
            </li>
            <li>
              The guest shall respect the host and the rest of the participants
              and the place of the meeting, and shall not interrupt during the
              testimony.{" "}
            </li>
            <li>
              The guest is responsible to arrive at the meeting for which he has
              registered, and to inform Zikaron BaSalon and the host as soon as
              possible inasmuch as he does not intent to participate in the
              meeting.
            </li>
            <li>
              The guest declares that he has no legal, contractual or other
              preclusion from participating in the meeting and that all the
              details that he transferred to Zikaron BaSalon on the website (or
              by any other method) are correct and accurate.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>PARTICIPATION FREE OF CHARGE </LiTitle>{" "}
            <LiTextBold>
              It shall be clarified that the testifier and the host are carrying
              out their roles on a voluntary basis and without a fee; that the
              meetings are free of charge for the participants; and that no
              charge shall be made for the event and/or the testimony at the
              meetings.
            </LiTextBold>
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>THE ACCURACY OF THE DETAILS </LiTitle> The participants
            undertake to enter onto the website accurate, updated and genuine
            details only. Moreover, Zikaran BaSalon has no responsibility for
            erroneous entries of the details of the participants and none of the
            participants shall have any plea and/or demand for such vis-à-vis
            Zikaron BaSalon or its representative. Inasmuch as Zikaron BaSalon
            shall discover that a participant entered erroneous details, it is
            permitted to delete the participant’s details from the website
            immediately and to prohibit his participation in meetings and/or the
            use of the website.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>PUBLICATION OF DETAILS</LiTitle> Details of the meetings
            (the first name of the guest, town and street name) shall be
            disclosed on the website and this so that the surfer shall be able
            to decide whether he wishes to participate in meetings.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>SAFEGUARDING PRIVACY</LiTitle> Prior to and during the
            meetings, the participants could be exposed to personal details
            about other participants and in particular the details of the
            testifiers and the hosts. This is information which has been
            disclosed by other participants independently and from choice, and
            Zikaron BaSalon is not responsible for its very disclosure or the
            use made of the information as aforementioned by any of the
            participants. By their very participation in the meetings the
            participants undertake not to make use of the details which were
            disclosed to them, apart from use for the purpose of coordinating
            the meetings and their execution, and not to transfer them to any
            third party without the consent of the participant to disclose the
            information in advance.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>PUBLICATION OF DETAILS OF THE PARTICIPANTS</LiTitle>
          </P>
          <ListSec>
            <li>
              Zikaron Basalon is permitted to photograph the meetings and upload
              them onto the website and/or any other media at the discretion of
              Zikaran BaSalon, and there shall be no claim about such by any of
              the participants. Inasmuch as a participant does not wish for his
              photograph or his details to be published, the participant shall
              contact Zikaron BaSalon in advance and in writing to hide/blur his
              photograph and/or his other details.
            </li>
            <li>
              The participants agree that photographs and/or video clips
              inasmuch as they shall be filmed during the meetings shall be
              published on the website and/or publications on behalf of Zikaron
              BaSalon in any shape or form whatsoever and in any media
              whatsoever, and that the participants shall not be entitled to any
              consideration for such.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>DATABASE</LiTitle>It shall be clarified that at the time of
            registration to the website, your details shall be automatically
            saved on the Zikaron BaSalon database (“the database”) and your
            registration to the website constitutes your consent for such. It
            shall be clarified that if you do not wish to be included in the
            Zikaron BaSalon database, Zikaron BaSalon shall not be able to
            allocate you for meetings. The information shall be saved on the
            database for as long as is required for implementation of the
            objectives of the database.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>RECEIPT OF NOTICES </LiTitle> On registration to the
            website, the participants shall be requested to provide their
            explicit consent to receive notices, including questionnaires which
            shall be sent from time to time in order to improve and streamline
            Zikaron BaSalon’s activity, by email, post, text messages and
            telephone calls from Zikaron BaSalon or its representative.
            Furthermore, the participants confirm receipt of notices with a
            marketing and/or commercial nature from Zikaron BaSalon by
            electronic methods. At any stage you may request removal from
            Zikaron BaSalon’s distribution list by writing to the email address:
            <a
              href="mailto:info@zikaronbasalon.com"
              target="_self"
              data-content="info@zikaronbasalon.com"
              data-type="mail"
            >
              info@zikaronbasalon.com
            </a>
            your request will be handled within fourteen (14) working days,
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>INTELLECTUAL PROPERTY </LiTitle>
          </P>
          <ListSec>
            <li>
              All the data, designs and information found on the website, apart
              from information found in links to other websites directed to by
              the website and/or that oculd refer to them (“website content”),
              are the exclusive property of Zikaron BaSalon, and the information
              and/or the services inasmuch as they are provided by it on the
              website should not be considered to award any license whatsoever
              or any rights whatsoever to the website content and/or the
              intellectual property rights of Zikaron BaSalon or third parties,
              accordingly. “Intellectual property rights” in these regulations
              means rights in any shape or form to the website content, the
              concept behind the foundation of the website, including copyright,
              computer codes, user interfaces, trademarks, designs, models,
              trade names and business names, knowhow and information, methods,
              plans, technologies, technical information, corporate information,
              trade secrets and any parallel or derived right in any website of
              the aforementioned, whether it is written or not, in Israel or
              worldwide. The intellectual property rights are under the sole and
              exclusive ownership of Zikaron BaSalon. The website content should
              not be duplicated or published in entirety or in part and/or use
              should not be made of the information therein, including
              commercial use, without the explicit consent in advance and in
              writing by Zikaron BaSalon. Furthermore, no amendments should be
              made to the website, duplication, distribution, transmission,
              presentation to the public, photocopy, publishing or transfer to a
              third party of any part of the website content without receiving
              the consent of Zikaron BaSalon in advance and in writing.
            </li>
            <li>
              Any advertisement presented on the website on behalf of an entity
              that is not Zikaron BaSalon is the property of the advertiser and
              under its sole responsibility, and no use should be made of it
              that harms the advertiser’s rights.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>LIMITATION OF LIABILITY </LiTitle>
          </P>
          <ListSec>
            <li>
              Zikaron BaSalon is not liable for any delay in a meeting or
              cancellation of a meeting for any reason whatsoever and does not
              undertake to advise of a cancellation or a delay as aforementioned
              to any of the participants. Furthermore Zikaron BaSalon is not
              liable for the comfort and/or the accessibility and/or any other
              conditions at the place of the meeting, the scale or the nature of
              the contents that shall be raised at the meeting, the identity of
              the participations in the meeting, the nature of the meeting
              and/or the discussions at the meeting inasmuch as they shall
              develop. The participants or their representatives have no and
              shall not have any plea and/or claim and/or demand in regard to
              all of the aforementioned against Zikaron BaSalon. Furthermore,
              Zikaron BaSalon has no liability for any damage, direct or
              indirect, or for any harm whatsoever that shall be caused to any
              of the participants during the meeting for any reason whatsoever,
              and as a consequence of such none of the participants or third
              parties shall have any claim and/or plea against Zikaron BaSalon
              or its representative.
            </li>
            <li>
              The information presented on the website appears as is, as it is
              received from the participants or from other entities. Zikaron
              BaSalon is not and shall not be liable, directly or indirectly,
              for the measure of accuracy, the truth and the reliability of the
              information as it is received from the participants or any third
              party. Reliance on the content of the website is under the full
              responsibility of the surfers.
            </li>
            <li>
              The use of the website and the services offered on it is at your
              discretion and under your responsibility only. The use of the
              website and the contents are provided to you free of charge as is
              pursuant to a decision by Zikaron BaSalon and you shall not have
              any plea, claim or demand vis-à-vis Zikaron BaSalon or its
              representative for the properties of the use or the service, its
              abilities and its limitations, its suitability for your needs or
              the responses that the publication shall arouse (if at all), if
              and inasmuch as there shall be such on the website.
            </li>
            <li>
              Zikaron BaSalon shall do all that it is able to ensure the good
              order of the website. However, Zikaron BaSalon does not undertake
              that the services on the website shall be given in an orderly
              fashion or without breaks and/or disturbances, shall be executed
              with certainty and shall be immune from unauthorized access to the
              Zikaron BaSalon’s computers and/or software or from any damages,
              malfunctions, defects or failures, inter alia in the hardware,
              software, communication lines and systems, at Zikaron BaSalon or
              any of its suppliers or with your system, and you shall not have
              any claim vis-à-vis Zikaron BaSalon and/or the Zikaron BaSalon
              service providers in regard to such. You are aware of the fact
              that it is possible that in the future the service may not be
              available due ot maintenance, upgrading or for any other reason.
            </li>
            <li>
              Zikaron BaSalon shall do all that it is able in order to ensure
              that the links found on the website shall be in good order and
              shall lead the surfers to an active internet website.
              Notwithstanding the aforementioned Zikaron BaSalon does not have
              any liability for an inactive or inoperable or inappropriately
              secured link. Zikaron BaSalon is permiited at any time to delete
              links from the website that appeared on it in the past or to
              abstain from adding new links – all at its sole discretion. The
              very existence of the link to a certain external website within
              the website does not constitute confirmation that all the
              information on this external website is complete, trustworthy,
              updated and reliable.
            </li>
            <li>
              Zikaron BaSalon shall be permitted at any time to discontinue the
              website and/or to change its structure, its appearance, the method
              of its operation and the availability of the services and the
              products offered on it (inasmuch as they are offered) from time to
              time and this without notifying the surfers of such. Use of the
              website after any change or update whatsoever to the terms of use
              of the website constitutes your consent to the updated terms of
              the website. In any event, the participants shall not have any
              plea or demand vis-à-vis Zikaron BaSalon in regard to the
              availability of the website, the content of the website and
              execution of changes or updates as stated in this section.
            </li>
            <li>
              Use of the website is subject to all the relevant local, state and
              international, laws and regulations and the participants undertake
              to act pursuant to any law in regard to the use of the website and
              its services and to make lawful, reasonable and fair use only of
              the website.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>
              ADVERTISING BY THIRD PARTIES, LINKS TO OTHER WEBSITES
            </LiTitle>{" "}
            The website could include, from time to time, links to external
            websites which are not related to and do not belong to Zikaron
            BaSalon (hereinafter: “external websites”). Zikaron BaSalon is not
            liable for the good order and/or the content of the external
            websites and/or use of the external websites, and it has no and
            shall not have any liability, control or possibility of supervising
            the contents found on the external websites, and/or the privacy
            policies of the external websites. Nothing by the very appearance of
            the links on the website shall constitute a recommendation by
            Zikaron BaSalon to visit them. Your visit to the other websites is
            at your discretion and under your sole responsibility.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>MISCELLANEOUS</LiTitle>
          </P>
          <ListSec>
            <li>
              Zikaron BaSalon does not discriminate based on age, gender, race,
              ethnicity, nationality, religion, sexual preference or any other
              status.{" "}
            </li>
            <li>
              Zikaron BaSalon reserves its right to cancel or refuse to hold a
              meeting and this at its sole discretion.{" "}
            </li>
            <li>
              Zikaron BaSalon is permitted to assign and/or transfer and/or
              convert its rights pursuant to these regulations, or part of them,
              to any corporation or third party entity at its sole discretion
              and without the need to notify of such in advance.
            </li>
            <li>
              The laws of the State of Israel shall be imposed on these
              regulations. The sole jurisdiction for any matter relating to
              these regulations and the use of the website is the authorized
              courts in the Tel Aviv-Jaffa area.
            </li>
            <li>
              If any of the terms of these regulations shall be found to be
              illegal, invalid or unenforceable for any reason, this term shall
              be deleted from the regulations, and its deletion shall not have
              an effect on the legality of the rest of the terms of the
              regulations and their validity.
            </li>
          </ListSec>
        </li>
      </ListMain>
    </TermsContainer>
  );
};

export default PolicyTermsEng;
